import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import emailjs from "emailjs-com";

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [formStatus, setFormStatus] = useState("");
  const [captchaToken, setCaptchaToken] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCaptcha = (token) => {
    setCaptchaToken(token); // Save the reCAPTCHA token
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!captchaToken) {
      setFormStatus("Please complete the CAPTCHA.");
      return;
    }

    // EmailJS Integration
    emailjs
      .send(
        "service_g3t50ha", // EmailJS Service ID
        "template_1lygj6n", // EmailJS Template ID
        formData,           // The form data
        "iHMjNwVnW9CZqWlmM"   // EmailJS Public Key
      )
      .then(
        (response) => {
          console.log("SUCCESS!", response.status, response.text);
          setFormStatus("Thank you! Your message has been sent.");
          setFormData({ name: "", email: "", phone: "", message: "" });
        },
        (error) => {
          console.error("FAILED...", error);
          setFormStatus("Oops! Something went wrong. Please try again.");
        }
      );
  };

  return (
    <div className="form-container">
      <form className="contact-form" onSubmit={handleSubmit}>
        <label className="label" htmlFor="name">
          Name:  *
        </label>
        <input
          className="input"
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Enter your name"
          required
        />

        <label className="label" htmlFor="email">
          Email:  *
        </label>
        <input
          className="input"
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Enter your email"
          required
        />

        <label className="label" htmlFor="phone">
          Phone:
        </label>
        <input
          className="input"
          type="phone"
          id="phone"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          placeholder="Enter your phone number"
        />

        <label className="label" htmlFor="message">
          Message:  *
        </label>
        <textarea
          className="textarea"
          id="message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          placeholder="Enter your message"
          required
        />

        <p>* Required fields</p>

        <ReCAPTCHA
          sitekey="6Ldt1NASAAAAAHgADv7GfpPc6BGl8XTR-m1cJxYs" // reCAPTCHA site key
          onChange={handleCaptcha}
        />

        <button className="button" type="submit">
          Submit
        </button>
      </form>
      {formStatus && <p className="successMessage">{formStatus}</p>}
    </div>
  );
};

export default ContactPage;
